t = require('app/scripts/views/internal/teacup-with-helpers')('member_gold_earned')

module.exports = t.renderable ({ hasInvitations, joinedNames, localizedCongratulations, showClose, hasGold }) ->

  t.div '.window-module.gold-earned-modal', ->
    if showClose
      t.a '.icon-lg.icon-close.dark-hover.gold-earned-modal-close.js-close-modal', { href: '#' }

    t.img '.gold-earned-modal-image', { src: require('resources/images/TrelloGoldIcon.png') }

    t.h1 ->
      if hasInvitations
        t.format 'youve-earned-trello-gold'
      else
        t.format 'youve-got-trello-gold'

    t.p ->
      t.text localizedCongratulations

    t.p ->
      t.format 'the-following-people-have-joined-trello-on-your-recommendation-or-invite'
      t.ul ->
        joinedNames.forEach (name) ->
          t.li -> t.text name

    t.p '.gold-earned-modal-learn-more.quiet', ->
      t.a { href: '/gold' }, ->
        t.format 'learn-more-about-trello-gold'

    if !hasGold
      t.a '.gold-earned-modal-button.button.primary.js-start-using-gold', { href: '#' }, ->
        t.format 'start-using-trello-gold'

    if showClose
      t.p '.quiet', { style: 'margin-top: 16px;' }, ->
        t.format 'you-can-visit-your-trello-gold-page-later-to-redeem-your-credits'
        t.a '.js-close-modal', { href: '#' }, ->
          t.text ' '
          t.format 'okay-thanks-close-this-header-thing'
